import { render, staticRenderFns } from "./StepConnectExtensions.vue?vue&type=template&id=5acd5746&scoped=true"
import script from "./StepConnectExtensions.vue?vue&type=script&lang=js"
export * from "./StepConnectExtensions.vue?vue&type=script&lang=js"
import style0 from "./StepConnectExtensions.vue?vue&type=style&index=0&id=5acd5746&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd5746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acd5746')) {
      api.createRecord('5acd5746', component.options)
    } else {
      api.reload('5acd5746', component.options)
    }
    module.hot.accept("./StepConnectExtensions.vue?vue&type=template&id=5acd5746&scoped=true", function () {
      api.rerender('5acd5746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepConnectExtensions.vue"
export default component.exports